<script lang="ts">
export default {
  name: 'Toggle',
};
</script>

<script setup lang="ts">
const model = defineModel<boolean>();

const props = defineProps<{
  id?: string;
  label: string;
  variant?: 'default' | 'primary' | 'secondary' | 'accent' | 'neutral' | 'success' | 'warning' | 'info' | 'error';
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  disabled?: boolean;
}>();

const getVariantClass = (variant?: string) => {
  switch (variant) {
    case 'primary':
      return 'tw:toggle-primary';
    case 'secondary':
      return 'tw:toggle-secondary';
    case 'accent':
      return 'tw:toggle-accent';
    case 'neutral':
      return 'tw:toggle-neutral';
    case 'success':
      return 'tw:toggle-success';
    case 'warning':
      return 'tw:toggle-warning';
    case 'info':
      return 'tw:toggle-info';
    case 'error':
      return 'tw:toggle-error';
    case 'default':
    default:
      return 'tw:toggle-primary';
  }
};

const getSizeClass = (size?: string) => {
  switch (size) {
    case 'xs':
      return 'tw:toggle-xs';
    case 'sm':
      return 'tw:toggle-sm';
    case 'lg':
      return 'tw:toggle-lg';
    case 'xl':
      return 'tw:toggle-xl';
    case 'md':
    default:
      return 'tw:toggle-md';
  }
};
</script>

<template>
  <label
    :for="id"
    class="tw:label tw:flex tw:items-center tw:gap-0">
    <input
      :id="id"
      type="checkbox"
      v-model="model"
      :checked="model"
      :disabled="disabled"
      class="tw:toggle"
      :class="[getVariantClass(props.variant), getSizeClass(props.size)]" />

    <span class="tw:label-text tw:cursor-pointer tw:pl-2 tw:select-none tw:text-sm">
      {{ label }}
    </span>
  </label>
</template>
